import React, {Component} from 'react';
import axios from 'axios'
//import Serialize from 'php-serialize'
import {API_KEY, API_BASE_URL} from "../application/config";
import LeeslijstItem from './LeeslijstItem'

export default class Leeslijst extends Component {

    constructor() {
        super();
        this.state = {
            isOpen: false,
            leeslijstItems: null
        }
    }


    onHeaderClick = () => {
        const {leeslijst} = this.props;
        const leeslijstId = leeslijst.zoeklijst ? leeslijst.zoeklijst : leeslijst.id;

        if (!this.state.leeslijstItems) {
            let url = `${API_BASE_URL}zoeklijstitems/?transform=1&token=${API_KEY}&filter=zoeklijstID,eq,${leeslijstId}`;
            axios.get(url).then((response) => {

                let rawItems = response.data.zoeklijstitems;
                rawItems = rawItems.sort((a, b) => a.zoekresultaat._titel < b.zoekresultaat._titel ? -1 : 1)
                //unserialisation gebeurt nu in de api op de server, dus hier niet meer nodig
                //rawItems.forEach(item => item.zoekresultaat = Serialize.unserialize(item.zoekresultaat));

                this.setState({
                    leeslijstItems: rawItems,
                    isOpen: !this.state.isOpen
                });
            }).catch((error) => console.log('ERROR', error))
        } else {
            this.setState({isOpen: !this.state.isOpen});
        }
    }


    onKoppelButtonClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const {callback, leeslijst} = this.props;
        callback(leeslijst);
    }

    render() {

        const {isOpen, leeslijstItems} = this.state;
        const {leeslijst, buttonLabel, edit, author, localeManager} = this.props;
        return (
            <div className='item-group-condensed' onClick={this.onHeaderClick}>
                <div className="ig-header">
                    <h2 className="ig-header-title element_toggler leeslijst-header"
                        aria-controls="group_1"
                        aria-expanded="true"
                        aria-label="Item Group Header toggle item visibility"
                        role="button">
                        <div>{
                            isOpen ?
                                <i className="icon-mini-arrow-down"></i>
                                :
                                <i className="icon-mini-arrow-right"></i>
                        }
                            {leeslijst.label} {author && <em className='leeslijst-author'>({leeslijst.userUpn})</em>}</div>
                        {edit && <button onClick={this.onKoppelButtonClick}>{buttonLabel}</button>}
                    </h2>
                </div>

                {((!leeslijstItems ||leeslijstItems.length === 0) && isOpen) && <p>Geen titels in deze lijst.</p>

                }
                {(leeslijstItems && isOpen) && <ul className='ig-list'>
                    {leeslijstItems.map(leeslijstItem => {
                        if (!leeslijstItem.zoekresultaat.publicatietype)
                            return null;

                        if (!leeslijstItem.zoekresultaat._titel){
                            console.log('GEEN TITEL VOOR', leeslijstItem)
                            if (leeslijstItem.zoekresultaat.titel){
                                leeslijstItem.zoekresultaat._titel = leeslijstItem.zoekresultaat.titel
                            } else {
                                return null
                            }
                        }
                        return <LeeslijstItem
                            localeManager={localeManager}
                            className='ig-list'
                            key={leeslijstItem.id}
                            leeslijstItem={leeslijstItem}/>
                    })}
                </ul>
                }
            </div>
        );
    }
}
